import { render } from "./Perpage.vue?vue&type=template&id=0a2a4a21"
import script from "./Perpage.vue?vue&type=script&lang=js"
export * from "./Perpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__